import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "el",
  class: "relative z-20 flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-robotoBold uppercase my-2 mx-4 whitespace-nowrap" }, " Filter by subject ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-robotoBold uppercase my-2 mx-4 whitespace-nowrap" }, " Filter by topic ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-robotoBold uppercase my-2 mx-4 whitespace-nowrap" }, " Filter by tag ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownArrowIcon = _resolveComponent("DropdownArrowIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ChallengesListDropdownFilterOption = _resolveComponent("ChallengesListDropdownFilterOption")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["flex items-center", _ctx.isDisabled ? 'pointer-events-none' : 'pointer-events-auto']),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOpenState && _ctx.toggleOpenState(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-base", {
          'text-cebai-base-dark': !_ctx.isDisabled,
          'text-cebai-grey-dark': _ctx.isDisabled,
        }])
      }, " Filter ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ml-1.5 transition-all duration-300", {
          'rotate-180': _ctx.isOpen,
          'rotate-0': !_ctx.isOpen,
        }])
      }, [
        _createVNode(_component_DropdownArrowIcon, {
          class: _normalizeClass({
            'text-cebai-primary fill-current': !_ctx.isDisabled,
            'text-cebai-grey-mid fill-current': _ctx.isDisabled,
          })
        }, null, 8, ["class"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute z-10 py-2 inline-block top-full right-0 rounded-xl cursor-pointer transition-all duration-300 bg-cebai-base-light shadow-[0_0_20px_0_rgba(51,51,51,0.1)]", {
        'mt-2 visible opacity-100': _ctx.isOpen,
        '-mt-2 invisible opacity-0': !_ctx.isOpen,
      }])
    }, [
      (_ctx.hasFilter)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            type: "text",
            class: "!absolute right-4 top-1",
            onClick: _withModifiers(_ctx.toggleClearFilter, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Clear filter ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.hasFilterSubjectOptions)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSubjectOptions, (filterSubjectOption, index) => {
              return (_openBlock(), _createBlock(_component_ChallengesListDropdownFilterOption, {
                key: index,
                label: filterSubjectOption.label,
                action: filterSubjectOption.action,
                selected: 
              _ctx.selectedFilterSubjectOptions.includes(filterSubjectOption.type)
            ,
                "has-border": true
              }, null, 8, ["label", "action", "selected"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.hasFilterTopicOptions)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTopicOptions, (filterTopicOption, index) => {
              return (_openBlock(), _createBlock(_component_ChallengesListDropdownFilterOption, {
                key: index,
                label: filterTopicOption.label,
                action: filterTopicOption.action,
                selected: 
              _ctx.selectedFilterTopicOptions.includes(filterTopicOption.label)
            ,
                "has-border": true
              }, null, 8, ["label", "action", "selected"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.hasFilterTagOptions)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTagOptions, (filterTagOption, index) => {
              return (_openBlock(), _createBlock(_component_ChallengesListDropdownFilterOption, {
                key: index,
                label: filterTagOption.label,
                action: filterTagOption.action,
                selected: _ctx.selectedFilterTagOptions.includes(filterTagOption.label),
                "has-border": true
              }, null, 8, ["label", "action", "selected"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ], 2)
  ], 512))
}